export const MARKET_PAGE_POLLING_INTERVAL = 5000;
export const TRADE_PAGE_POLLING_INTERVAL = 5000;
export const IP_POLLING_INTERVAL = 5000;
export const PORTFOLIO_PAGE_POLLING_INTERVAL = 5000;
export const POLLING_ORDER_BOOK = 15000;
export const POLLING_INSTRUMENT_SPOT_RAW_PRICE = 5000;
export const POLLING_USER_PENDING_WITHDRAWABLE = 15000;
export const POLLING_USER_BALANCE = 5000;
export const POLLING_GRAPH = 15000;
export const POLLING_OPEN_ORDER_CREATE_TIME = 10000;
export const POLLING_HISTORY_POLLING = 10 * 1000;
export const POLLING_HISTORY_POLLING_DELAY = 5 * 1000;
export const POLLING_BLOCK_NUMBER = 3000;
